import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "", once = true }) => {
    const reduce = useReducedMotion();
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y: reduce ? 0 : y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, margin: "-70px" }}
            transition={{ duration: 0.9, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
};

export const MaskedLine = ({ children, delay = 0, className = "", play = true }) => (
    <span className={`block overflow-hidden pb-[0.08em] ${className}`}>
        <motion.span
            className="block will-change-transform"
            initial={{ y: "115%" }}
            animate={play ? { y: "0%" } : {}}
            transition={{ duration: 1.05, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);

export const Eyebrow = ({ children, className = "" }) => (
    <p
        className={`font-mono text-xs sm:text-sm uppercase tracking-[0.3em] text-[#0066FF] flex items-center gap-3 ${className}`}
    >
        <span className="inline-block h-px w-8 bg-[#0066FF]/70" aria-hidden="true" />
        {children}
    </p>
);
